import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["resendLink"]
  }

  connect() {
    setTimeout(() => {
      this.resendLinkTarget.classList.remove("invisible")
    }, 120000)
  }
}
